// extracted by mini-css-extract-plugin
module.exports = {"container":"teachers_container__3bRd3","sub_container":"teachers_sub_container__3ZGLA","image":"teachers_image__18KS_","data":"teachers_data__2kyso"};